import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Indisbursed(state = initialState, action) {
  switch (action.type) {
    case userConstants.INDISBURSED_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.INDISBURSED_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.INDISBURSED_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}